module.exports = __webpack_public_path__ + "img/2380.a1250598.gif";